import Vue from 'vue';
import waitUntil from "wait-until";

// TODO Make generic?
export default Vue.component('canvas--editor-admin-DocumentIframe', {

    inject: [
        'editorComponent',
    ],

    render(h)
    {
        return h('iframe', {
            on: {
                load: this.onIframeLoaded,
            },
            attrs: {
                src: this.url,
                'data-size': this.size,
                'class': 'canvas::editor-admin-DocumentIframe w-full',
                style: 'opacity: .5; pointer-events: none',
                allowTransparency: 'true',
                frameborder: '0',
            },
            style: {
                height: '100%', //this.height + 'px',
            }
        });
    },

    props: {
        height: Number,
        canvasVersion: Object,
        scale: Number,
        activeMode: String,
    },

    data()
    {
        return {
            iframeApp: null,
            bridge: {
                props: [
                    'canvasVersion',
                    'scale',
                    'activeMode',
                ],
            },
            bridgeWatchers: [],
        };
    },

    methods: {

        async manageUrl()
        {
            // Stop watching bridge.
            this.destroyBridge();

            // Loose the ref.
            this.iframeApp = null;

            // Navigate to url.
            this.$el.contentDocument.location.href = this.url;
        },

        async onIframeLoaded()
        {
            // @ugly common.canvas.editor.canvas.Blocks in Iframe will use this to set its $parent.
            this.$el.contentWindow.canvasEditorIframeComponent = this;

            await this.waitForIframeAppReady();

            this.initBridge();
            this.showLoaded();

            this.$emit('loaded');
        },

        async waitForIframeAppReady()
        {
            return new Promise(resolve =>
            {
                waitUntil(40, 1000000, () => !!this.iframeApp, resolve);
            });
        },

        initBridge()
        {
            // Loop props.
            for (let prop of this.bridge.props)
                this.initBridgeProp(prop);
        },

        initBridgeProp(prop)
        {
            // Watch
            this.bridgeWatchers.push(this.$watch(prop, newVal =>
            {
                // Get primitive value.
                let valCopy = newVal !== Object(newVal) ? newVal : JSON.parse(JSON.stringify(newVal));

                // Set in iframe.
                this.iframeApp.pageComponent[prop] = valCopy;
            }, {
                deep: true,
                immediate: true,
            }));
        },

        destroyBridge()
        {
            // Call unwatchers.
            for (let unwatcher of this.bridgeWatchers)
                unwatcher();

            this.bridgeWatchers = [];
        },

        showLoaded()
        {
            $(this.$el)
                .css({
                    opacity: 'initial',
                    pointerEvents: 'auto',
                });
        },

    },

    // TODO Introduce proxy / broker for passing through values and events?
    watch: {

        'editorComponent.galleryDraggingBlock'(newVal)
        {
            // @ugly
            // Pass trough.
            this.iframeApp.pageComponent.galleryDraggingBlock = newVal;
        },

        'canvasVersion': {
            deep: true,
            async handler(newVal, oldVal)
            {
                // Load new url?
                if (newVal.id != oldVal.id)
                    await this.manageUrl();

                // TODO @ugly Update state to iframe.
                if (this.iframeApp)
                    this.iframeApp.pageComponent.state.initialCanvasVersion = JSON.parse(JSON.stringify(newVal));
            },
        },

    },

    computed: {

        url()
        {
            return '/admin/canvas-editor/' + this.canvasVersion.id + '/render';
        },

    },

});
